export enum PathValidityEnum {
  A = 'Valid',
  V = 'Invalid',
}
